import React from 'react'
import { Link } from 'react-router-dom'
import { Container, Row, Col } from 'reactstrap'
import { cartActions } from '../redux/slices/cartSlice'
import { useSelector, useDispatch } from 'react-redux'

import Helmet from '../components/Helmet/Helmet'
import CommonSection from '../components/UI/CommonSection'
import '../styles/cart.css'
import { formatPrice } from '../utils/formatPrice'

const Cart = () => {
  const cartItems = useSelector((state) => state.cart.cartItems)

  const totalAmount = useSelector((state) => state.cart.totalAmount)

  return (
    <Helmet title='Cart'>
      <CommonSection title='Shopping Cart' />

      <section>
        <Container>
          <Row>
            <Col lg='9'>
              {cartItems.length === 0 ? (
                <div className='cart__empty'><i className='ri-shopping-bag-3-line'></i><h2>Your bag is ready when you are.</h2><p>Explore the collection and add something worth getting excited about.</p><Link className='buy__btn' to='/shop'>Start shopping</Link></div>
              ) : (
                <table className='table bordered'>
                  <thead>
                    <tr>
                      <th>Image</th>
                      <th>Title</th>
                      <th>Price</th>
                      <th>Qty</th>
                      <th>Delete</th>
                    </tr>
                  </thead>

                  <tbody>
                    {cartItems.map((item, index) => (
                      <Tr item={item} key={index} />
                    ))}
                  </tbody>
                </table>
              )}
            </Col>
            <Col lg='3'>
              <div className='cart__summary'>
                <h6 className='d-flex align-items-center justify-content-between'>
                  Subtotal  
                  <span className='fs-4 fw-bold'>{formatPrice(totalAmount)}</span>
                </h6>
                <p>Taxes and shipping are calculated at checkout.</p>
                <Link className='buy__btn w-100' to='/checkout'>Secure checkout</Link>
                <Link className='cart__continue' to='/shop'>Continue shopping</Link>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </Helmet>
  )
}

const Tr = ({ item }) => {
  const dispatch = useDispatch()

  const deleteProduct = () => {
    dispatch(cartActions.deleteItem(item.id))
  }

  return (
    <tr>
      <td>
        <img src={item.imgUrl} alt={item.productName} />
      </td>
      <td>{item.productName}</td>
      <td>{formatPrice(item.price)}</td>
      <td>{item.quantity}</td>
      <td>
        <i
          onClick={deleteProduct}
          className='ri-delete-bin-line'
        ></i>
      </td>
    </tr>
  )
}

export default Cart
